import React from "react";

//---------------------------------------------------------------------------
// MUI Components
//---------------------------------------------------------------------------
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Icon from "@mui/material/Icon";

//---------------------------------------------------------------------------
// Application Components
//---------------------------------------------------------------------------
import ColumnHeader from "../../components/common/ColumnHeader.jsx";

function EngineeringUsersHeader({
  // Props
  sort,
  setSort,
}) {
  //---------------------------------------------------------------------------
  // Update the `sort` object for use by sortManager
  //---------------------------------------------------------------------------
  const handleSortSelection = (field) => setSort(field);

  return (
    <Box sx={{ p: 1 }}>
      <Grid container id="headersRow" sx={{ alignItems: "flex-end" }}>
        <Grid sx={{ display: { xs: "none", sm: "block" } }} size="auto">
          <Icon sx={{ m: 1 }} />
        </Grid>
        <Grid size="grow">
          <ColumnHeader
            id="name"
            display="Name"
            sortField={sort.field}
            reverseSort={sort.reverse}
            onClick={handleSortSelection}
          />
        </Grid>
        <Grid size={2}>
          <ColumnHeader
            id="hourlyRate"
            display="Hourly Rate"
            sortField={sort.field}
            reverseSort={sort.reverse}
            onClick={handleSortSelection}
          />
        </Grid>
        <Grid size={2}>
          <ColumnHeader
            id="weeklyWorkingHours"
            display="Working Hours"
            sortField={sort.field}
            reverseSort={sort.reverse}
            onClick={handleSortSelection}
          />
        </Grid>
        <Grid size={2}>
          <ColumnHeader
            id="weeklyJiraHours"
            display="Jira Hours"
            sortField={sort.field}
            reverseSort={sort.reverse}
            onClick={handleSortSelection}
          />
        </Grid>
      </Grid>
    </Box>
  );
}

export default EngineeringUsersHeader;
